export default __webpack_public_path__ + "static/media/banner-mb.771ad1a1.webp";